import { makeStyles, shorthands } from '@fluentui/react-components';

const useServiceContractPdfStyles = makeStyles({
    pdfContainer: {
        width: '90%',
        marginLeft: 'auto',
        marginRight: 'auto'
    },
    pageContainer: {
        overflowY: 'scroll',
        overflowX: 'hidden',
        ...shorthands.border('2px', 'solid', 'lightgray'),
        ...shorthands.borderRadius('5px')
    }
});

export default useServiceContractPdfStyles;
